import { apiHelper } from '../../common/utils';
import mockHelper from '../../common/mockHelper';
export const steetToProduct = (params) => {
    let options = {
        url: '/shop/web/similar_items',
        method: 'get',
        params,
    }
    let promise;
    if (process.env.REACT_APP_MOCK == 'MOCK2') {
        promise = mockHelper('street_snap_detail')
    } else {
        promise = apiHelper(options)
    }
    return promise;
}

export const influencerPage = (params) => {
    // http://cloud-dt.deja.fashion/shop/web/street_snaps?influencer_id=12312&pageNum=1&pageSize=18

    let options = {
        url: '/shop/web/street_snaps',
        method: 'get',
        headers: {'uid': -100},
        params,
    }
    let promise;
    if (process.env.REACT_APP_MOCK == 'MOCK2') {
        promise = mockHelper('personal_page1')
    } else {
        promise = apiHelper(options)
    }
    return promise;
}

export const productMore = (params) => {
    let options = {
        url: '/shop/web/similar_items',
        method: 'get',
        params,
    }
    let promise;
    if (process.env.REACT_APP_MOCK == 'MOCK') {
        promise = mockHelper('product_more')
    } else {
        promise = apiHelper(options)
    }
    return promise;
}


// WEBPACK FOOTER //
// ./src/features/api/streetSnap.js